export interface DataEntity_Resolution_10_Interface {
    id: number,
    range_min:string,
    range_max:string,
    scale:string,
  }
  
  export function Empty_DataEntity_Resolution_10_Interface(): DataEntity_Resolution_10_Interface {
    return {
      id: 0,
      range_min:'',
      range_max:'',
      scale: '',
    }
  }
  

